import React from 'react';
import { Routes as ReactRoutes, Route, Outlet, useRoutes, Link, useParams } from "react-router-dom";
import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/es/locale/zh_TW';
import RouteSetting from './RouteSetting';
import MainPage from './MainPage';
import PageSetting from './PageSetting';
import NavBar from './components/NavBar';
import ComponentData from './ComponentData';
import Portal from './description/Portal';
// import Article from './description/Article';
import Management from './Management';
import MoreContent from './MoreContent';
import Appointment, { AppointmentManagement } from './Appointment';
import Editpage from './Editpage';
import ArticleManagement from './ArticleManagement';
import NavBarBackend from './components/NavBarBackend';
import ProtalMainPage from './ProtalMainPage';
import StreamingManagement from './StreamingManagement';
import Live from "../audio_recorder/views/Live";
import MainRouteNews from './../../components/news/MainRoute'
import New from '../news/views/New';

const { ConfigContext } = ConfigProvider


const MainRoute = ({
    prefixTitle = '澄欣科技',
    admin = false
}) => {
    const configContext = useContext(ConfigContext)
    const language = configContext.locale.locale
    const [permissionData, setPermissionData] = useState([]);
    const [routeData, setRouteData] = useState([]);
    const [routeResult, setRouteResult] = useState([]);
    const [menuItem, setMenuItem] = useState([]);

    const jwt = admin ? {
        element: <JWT />
    } : {}
    useEffect(() => {
        axios.get('/dynamicWebsite/frontend/permission', {
            params: {
                classify_structure_id: 5,
                classify_structure_type_id: 0
            }
        })
            .then(response => {
                setPermissionData(response?.data['data'])
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }, [])

    useEffect(() => {
        setRouteData(changeToRouteElement(permissionData, []))
        let menuDataTemp = changeMenuElement(permissionData, [])
        setMenuItem([
            ...menuDataTemp,
            {
                path: `appointment`,
                element: <Appointment />,
                label: <Link to={`/officialweb/frontend/appointment`} style={{ textDecoration: 'none', color: 'black' }}> 聯絡我們</Link>,
                key: `/officialweb/frontend/appointment`,
                // children: [],
                index: false,
            }
        ])
    }, [permissionData]);

    useEffect(() => {
    }, [menuItem]);

    const changeToRouteElement = (treeData_, result_) => {
        let treeData = [...treeData_]
        let result = [...result_]

        for (let i = 0; i < treeData_.length; i++) {
            const node = treeData[i];

            treeData = [...treeData.map((map_item, map_index) => {
                if (map_index === i) {
                    if (map_item.path_check === 1) {
                        let path = map_item.name
                        result = [
                            ...result,
                            {
                                path: `:path`,
                                element: <ProfileComponentWrapper />,
                                label: <Link to={`/officialweb/frontend/${path}`} style={{ textDecoration: 'none', color: 'black' }}> {map_item.name}</Link>,
                                key: `/officialweb/frontend/${path}`,
                                // children: [],
                                index: false,
                                name: map_item.name
                            }
                        ]
                        return {
                            ...map_item
                        }
                    }
                    else {
                        let path = map_item.path
                        return {
                            element: <ProfileComponentWrapper />,
                            label: <a href={path} style={{ textDecoration: 'none', color: 'black' }}> {map_item.name}</a>,
                            // children: [],
                            index: false,
                            name: map_item.name
                        }
                    }
                }
                else {
                    return {
                        ...map_item
                    }
                }
            })];
            if (node.children) {
                result = changeToRouteElement(node.children, result);
            }
        }
        return result;
    }

    const changeMenuElement = (treeData_) => {
        let treeData = [...treeData_]
        for (let i = 0; i < treeData_.length; i++) {
            const node = treeData[i];

            treeData = [...treeData.map((map_item, map_index) => {
                if (map_index === i) {
                    if (map_item.path_check === 1) {
                        let path = map_item.name

                        return {
                            path: `:path`,
                            element: <ProfileComponentWrapper />,
                            label: <Link to={`/officialweb/frontend/${path}`} style={{ textDecoration: 'none', color: 'black' }}> {map_item.name}</Link>,
                            key: `/officialweb/frontend/${path}`,
                            // children: [],
                            index: false,
                        }
                    }
                    else {
                        let path = map_item.path
                        return {
                            // element: <ProfileComponentWrapper />,
                            label: <a href={path} style={{ textDecoration: 'none', color: 'black' }}> {map_item.name}</a>,
                            // children: [],
                            index: false,
                        }
                    }
                }
                else {
                    return {
                        ...map_item
                    }
                }
            })];
            if (node.children) {
                const data = changeMenuElement(node?.children);
                treeData = [...treeData.map((map_item, map_index) => {
                    if (map_index === i) {
                        return {
                            ...map_item,
                            children: data
                        }
                    }
                    else {
                        return {
                            ...map_item,
                        }
                    }
                })];
            }
        }
        return treeData;
    }
    useEffect(() => {
        if (routeData.length !== 0) {
            console.log(routeData)
            let home = routeData[0]//取第一個route當首頁
            console.log(home)

            let indexRoute = [{
                ...home,
                path: ``,
                index: true,
                element: <ProfileComponentWrapper pageName={home.name} />,
            }]
            console.log(indexRoute)

            setRouteResult(
                [
                    {
                        path: "",
                        // element: admin ? <JWT /> : {},
                        children: [
                            {
                                path: "frontend",
                                label: '形象',
                                key: '/',
                                element: <NavBar menuData={menuItem} admin={admin} />,
                                children: [
                                    ...indexRoute,
                                    ...routeData,
                                    {
                                        path: `moreContent/:blogId`,
                                        element: <MoreContent prefixTitle={prefixTitle}/>,
                                        index: false,
                                    },
                                    {
                                        path: `appointment`,
                                        element: <Appointment prefixTitle={prefixTitle}/>,
                                        index: false,
                                    },
                                ]
                            }
                        ]
                    }
                ]
            )
        }
    }, [routeData]);

    const ProfileComponentWrapper = (
        {
            pageName = "",
        }
    ) => {
        const { path } = useParams();
        let titleName = ""
        if (path === undefined && pageName !== "") {
            titleName = pageName
            // console.log(titleName)
        }
        if (pageName === "" && path !== undefined) {
            titleName = path
        }

        return <MainPage prefixTitle={prefixTitle} title={titleName} />;
    };
    const Routes = () => {
        const elements = useRoutes(routeResult);
        return elements;
    }
    return (
        <>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: 'rgb(83, 183, 173)',
                    },
                }}
                locale={zhTW}>
                <Routes />
                <ReactRoutes>
                    <Route path={''} element={<Outlet />}>
                        <Route path={'/news/new/:news_id'} element={<New />} />
                    </Route>
                    {admin && (<>
                        <Route path={''} element={<JWT />}>
                            <Route path={'admin'} element={<NavBarBackend />}>
                                {/* <Route index element={<ProtalMainPage prefixTitle={prefixTitle} />} /> */}
                                <Route index element={<Management prefixTitle={prefixTitle} />} />
                                <Route path={'management'} element={<Management prefixTitle={prefixTitle}/>} />
                                <Route path={'routeSetting'} element={<RouteSetting prefixTitle={prefixTitle}/>} />
                                <Route path={'articlemanagement'} element={<ArticleManagement prefixTitle={prefixTitle}/>} />
                                <Route path={'appointment'} element={<AppointmentManagement prefixTitle={prefixTitle}/>} />
                                <Route path={'pageSetting/:permissionName'} element={<PageSetting prefixTitle={prefixTitle}/>} />
                                {/* <Route path={'StreamingManagement'} element={<StreamingManagement prefixTitle={prefixTitle}/>} /> */}
                                <Route path={'audio_recorder/liveAdmin/:RoomId'} element={<Live prefixTitle={prefixTitle} admin={true}/>} />
                                <Route path={'news/*'} element={<MainRouteNews />}/>
                                {/* <Route path={'editpage'} element={<Editpage prefixTitle={prefixTitle}/>} /> */}
                                {/* <Route path={'translationTest'} element={<TranslationTest />} /> */}
                                
                                {/* <Route path={'componentSetting'} element={<ComponentSetting />} /> */}
                                {/* <Route path={'componentData'} element={<ComponentData title={"測試"} />} /> */}
                            </Route>
                        </Route>
                    </>)}
                </ReactRoutes >
            </ConfigProvider >
        </>
    );
}
export default MainRoute;

const JWT = () => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )
    return <Outlet />
}
